export const getParamsFromUrl = (parameterNames: string[]) => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return parameterNames.map(parameterName => urlSearchParams.get(parameterName))
}
